var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"group":"dashboard-notification","width":"100%","max":3,"position":"bottom center"},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{staticClass:"tooltip dashboard-tooltip"},[_c('div',{staticClass:"tooltip-inner"},[_vm._v(_vm._s(props.item.title))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }